import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import SlideHomeStacks from "./Slide";

function StacksIndex() {
  const { i18n, t } = useTranslation();
  var stacksItems = t("Home.Stacks", { returnObjects: true });

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  const preventClick = (event) => {
    event.preventDefault();
  };

  const pcBoxItems = Array(5).fill(0);

  return (
    <div className="container-fluid home-stacks"  id="about">
      <div className="container">
        <div className="row">
          <div className="col-12 d-flex flex-column justify-content-center first-section">
            <div className="col-12 d-flex justify-content-center title-container">
              <div className="title-row d-flex align-items-center justify-content-center">
                <div className="title">
                  {stacksItems["What Tools Do I Use?"]}
                </div>
                <div className="animation-container-title"></div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 d-flex flex-column row-gap-4 second-section">
            <div className="col-12 list">
              <ul className="list-group">
                {Object.keys(stacksItems.List).map((key) => {
                  const listItem = stacksItems.List[key];
                  return (
                    <li
                      className="list-group-item bg-black text-white d-flex gap-3 border-0"
                      key={key}
                    >
                      <span className="badge bg-primary-p rounded-pill d-flex justify-content-center align-items-center">
                        <div className="bg-white dot-p">
                        </div>
                      </span>
                        {listItem}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
          <div className="col-12 col-lg-6 third-section">
            <div className="col-12 d-flex justify-content-center align-items-center pc-container">
              <div className="pandin-container-custom-pc">
                <div className="my-pc">
                  <div className="screen rounded-4">
                    <div className="pc-navbar d-flex justify-content-between align-items-center rounded-top-3">
                      <div className="circle-container d-flex gap-2">
                        <div className="pc-logo rounded-circle"></div>
                        <div className="pc-logo rounded-circle"></div>
                        <div className="pc-logo rounded-circle"></div>
                      </div>
                      <div className="pc-login rounded-1"></div>
                    </div>
                    <div className="first-section rounded-bottom-3">
                      {pcBoxItems.map((_, index) => (
                        <div className={`boxes item-${index}`}  key={index}>
                          <div className={`box rounded-2`}></div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="keyboard rounded-3">
                    <div className="border-start rounded-start-3"></div>
                    <div className="border-end rounded-end-3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 four-section">
            <div className="stack-resume">
              
            </div>
          </div>
          <div className="col-12 five-section">
            <div className="stack-slide rounded-2">
              <SlideHomeStacks />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StacksIndex;
